import { CubiqPrototypal } from "./CubiqPrototypal";
import * as CubiqTS from "./index";

export class CubiqPrototypalWrapper extends CubiqPrototypal {
  public unwrap: Function;

  private constructor(_serializedObject?: CubiqPrototypal) {
    super(_serializedObject);
  }

  public static wrap(type: any): CubiqPrototypal {
    if (new type() instanceof CubiqPrototypal) {
      // passthrough subclassing instances
      return new type();
    }

    let wrapper = new CubiqPrototypalWrapper();

    if (CubiqTS.moment.isMoment(type)) {
      wrapper.unwrap = function (serializedObject): CubiqTS.moment.Moment {
        let m = CubiqTS.moment();

        return Object.assign(m, serializedObject);
      };

      return wrapper;
    }

    if (type instanceof CubiqTS.BigNumber) {
      wrapper.unwrap = CubiqTS.BigNumber;

      return wrapper;
    }

    if (type instanceof CubiqTS.Long) {
      wrapper.unwrap = function (serializedObject): CubiqTS.Long {
        let l = new CubiqTS.Long(0);

        // probably should add .fromData() for restore prototype
        return Object.assign(l, serializedObject);
      };

      return wrapper;
    }

    throw new Error("Attempted to wrap unsupported PROTOTYPAL with CubiqSerializer");
  }
}
